import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Button, Grid2 as Grid, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ColDef, EditableCallbackParams } from "ag-grid-enterprise";
import { useState } from "react";
import { CatalogBucket } from "../../../models/CatalogBucket";
import { useBucketContext } from "../CatalogBucketContext";
const useStyles = makeStyles((theme: Theme) => ({
	buttons: {
		opacity: 0,
		transition: "opacity 0.1s ease-in-out",
		".ag-row-hover &": {
			opacity: 1,
		},
		".ag-row-focus &": {
			opacity: 1,
		},
		".ag-row-selected &": {
			opacity: 1,
		},
	},
}));
const cellStyle = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};

type Props = {
	setBucketId: Function;
	setShowEditModal: Function;
	setShowDeleteModal: Function;
	showContextMenu: Function;
};

export const useTableData = ({
	setBucketId,
	setShowEditModal,
	setShowDeleteModal,
	showContextMenu,
}: Props) => {
	const { state } = useBucketContext();
	const classes = useStyles();

	const rows: CatalogBucket[] =
		state.buckets?.map((bucket: CatalogBucket) => ({
			...bucket,
		})) || [];

	const [columnDefs] = useState<ColDef[]>([
		{
			field: "BucketName",
			headerName: "Name",
			minWidth: 20,
			flex: 3,
			cellStyle: cellStyle,
		},
		{
			field: "Capacity",
			headerName: "Capacity",
			minWidth: 20,
			flex: 2,
			cellStyle: cellStyle,
		},
		{
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid
						container
						justifyContent="flex-end"
						alignItems="flex-end"
						className={classes.buttons}
					>
						<Grid
							size={{ xs: 12 }}
							style={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "flex-end",
							}}
						>
							<Button
								onClick={() => {
									(async () => {
										setBucketId(params.data.BucketId);
										setShowEditModal(true);
									})();
								}}
							>
								<EditIcon style={{ height: "auto" }} color="primary" />
							</Button>
							<Button
								onClick={() => {
									(async () => {
										setBucketId(params.data.BucketId);
										setShowDeleteModal(true);
									})();
								}}
							>
								<DeleteIcon style={{ height: "auto" }} color="error" />
							</Button>
							<Button
								style={{}}
								onClick={(e) =>
									showContextMenu(e, params.data, "bucketsContext")
								}
								title="Options"
							>
								<FormatListBulletedSharpIcon
									style={{ height: "auto" }}
									color="action"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			minWidth: 330,
			maxWidth: 380,
			filter: false,
			autoHeaderHeight: true,
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
	]);

	const defaultColDef: ColDef = {
		sortable: true,
	};

	return { rows, columnDefs, defaultColDef };
};
